import RoomFeature1 from '@images/roomFeatures/sve-icon1.png';
import RoomFeature2 from '@images/roomFeatures/sve-icon2.png';
import RoomFeature3 from '@images/roomFeatures/sve-icon3.png';
import RoomFeature4 from '@images/roomFeatures/sve-icon4.png';
import RoomFeature5 from '@images/roomFeatures/sve-icon5.png';
import RoomFeature6 from '@images/roomFeatures/sve-icon6.png';

export const getRoomFeatureImage = (id) => {
  switch (id) {
    case 1:
      return RoomFeature1;
    case 2:
      return RoomFeature2;
    case 3:
      return RoomFeature3;
    case 4:
      return RoomFeature4;
    case 5:
      return RoomFeature5;
    case 6:
      return RoomFeature6;
  }
};

export const getRoomFeatureClass = (id) => {
  switch (id) {
    case 1:
      return 'fal fa-tv-retro';
    case 2:
      return 'fal fa-wifi';
    case 3:
      return 'fal fa-air-conditioner';
    case 4:
      return 'fal fa-dumpster-fire';
    case 5:
      return 'fal fa-phone-rotary';
    case 6:
      return 'fal fa-dryer-alt';
  }
};

export const fullBackendPath = (path) => {
  return `${process.env.BASE_URL}${path}`;
};

export const kebabCase = (str) =>
  str
    ?.match(
      /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
    )
    ?.join('-')
    ?.toLowerCase() || '';
